import { getUrl, postUrl } from '@/apiCalls/fetch';
import { selectIsNZ } from '@/context/display';
import { store } from '@/context/store';

import { ILookupName, ILookupResponse } from './lookupBusinessNameTypes';

export async function lookupBusinessName(name: string): Promise<ILookupName[]> {
    const state = store.getState();
    const isNZ = selectIsNZ(state);
    if (isNZ) {
        const response = await postUrl<ILookupName[]>('/api/abn/list', {
            country: 'NZ',
            name,
        });
        return response;
    }

    const url = `/api/abnLookup/name/${name}`;

    const response = await getUrl<ILookupResponse>(url);

    return response.data;
}
